
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPurRequestDtDialog extends Serenity.Extensions.GridEditorDialog<PoPurRequestDtRow> {
        protected getFormKey() { return PoPurRequestDtForm.formKey; }
        // protected getIdProperty() { return PoPurRequestDtRow.idProperty; }
        protected getLocalTextPrefix() { return PoPurRequestDtRow.localTextPrefix; }
        protected getNameProperty() { return PoPurRequestDtRow.nameProperty; }
        // protected getService() { return PoPurRequestDtService.baseUrl; }
        // protected getDeletePermission() { return PoPurRequestDtRow.deletePermission; }
        // protected getInsertPermission() { return PoPurRequestDtRow.insertPermission; }
        // protected getUpdatePermission() { return PoPurRequestDtRow.updatePermission; }

        protected form = new PoPurRequestDtForm(this.idPrefix);

        public qnNo: number;
        public purprice: number;
        public StkUnitT: string;
        public purratio: number;
        public purpz: number;
        public lsprun: number;
        public lookupconsignfg: number;
        public HdPostfg: number;

        constructor() {
            super();
            this.form = new PoPurRequestDtForm(this.idPrefix);

            this.form.SkuCode.changeSelect2(e => {
                var skucode: string = this.form.SkuCode.value;
                this.form.UnitChange.value = null


                if (!Q.isEmptyOrNull(skucode)) {

                    this.callpurunit();

                }
            });
            this.form.DiscText.changeSelect2(e => {
                this.distext();
            });
            this.form.DiscText.addValidationRule(this.uniqueName, e => {
                var totalAmt = this.form.BeforeDiscAmt.value;
                var disAmt = this.form.DiscAmt.value;
                if (totalAmt != null && disAmt != null && disAmt > 0 && disAmt > totalAmt) {
                    return "Discount can't be higher than total amount!";
                }
            });


            this.form.UnitChange.change(e => {

                var sku: string = this.form.SkuCode.value
                var skucode: string = Q.toId(this.form.SkuCode.value);
                var stku = this.StkUnit;
                var puru = this.PurUnit;
                // console.log(skucode)
                // console.log(sku)
                // console.log(stku)


                if (skucode != null) {
                   
                    if (!puru) {


                        this.callpurunit();
                    }
                    else if (!stku) {
                       this.CallSku();

                    }

                }
            });

            this.form.Qty.changeSelect2(e => {
                var skucode = Q.toId(this.form.Qty.value);
                if (skucode != null) {

                    this.Calamt();
                }
            });

            this.form.PurUnitPrice.changeSelect2(e => {
                var skucode = Q.toId(this.form.PurUnitPrice.value);
                if (skucode != null) {

                    this.Calamt();
                }
            });

            this.form.BeforeDiscAmt.changeSelect2(e => {
                var skucode = Q.toId(this.form.BeforeDiscAmt.value);
                if (skucode != null) {

                    this.Calamt();

                }
            });

            this.form.VatCode.changeSelect2(e => {
                var vat = Q.toId(this.form.VatCode.value);
                if (vat != null) {
                this.form.VatRate.value = Administration.CsVatCodeRow.getLookup().itemById[vat].VatRate

                    if(vat == 'N'){
                        this.form.VatType.value = 'N'
                    }else{
                        this.form.VatType.value = 'V'
                    }              
                
                    this.CalVat();
                }
            });







        }
        private get StkUnit() {
            return this.form.UnitChange.value != "0";
        }
        private get PurUnit() {
            return this.form.UnitChange.value != "1";
        }



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            

            let newBtn: Serenity.ToolButton =
            {
                title: "Save & next",
                hint: "Save and new",
                separator: false,
                cssClass: "button-saveandnew",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: (e) => {
                    e.preventDefault();
                    this.saveAndNew();
                }
            };
            buttons.push(newBtn)

            // buttons.push(this.applyChangesButton)


            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }

        private saveAndNew() {
            let e = this.entity; let f = this.form;
            // if (e.SkuCode == null) {
            //     e.SkuCode = f.SkuCode.value;

            // }
            this.save((response) => {
                let ent: PoPurRequestDtRow = {
                    SysDocNo: e.SysDocNo,
                    SupplierId: f.SupplierId.value,
                    WhsId: f.WhsId.value,
                    ShopId: f.ShopId.value
                };
                this.loadEntity(ent);
            });
        }
        protected afterLoadEntity() {
            let self = this;
            // this.toolbar.findButton('button-saveandnew').toggleClass('disabled', false);
            this.toolbar.findButton('clone-button').hide();
            this.toolbar.findButton('localization-button').hide();
            this.toolbar.findButton('undo-delete-button').hide();

                  
            this.syscuscheck();
            this.HdPostfg = 0;
           
                var sysdoc = this.entity.SysDocNo;
                console.log(sysdoc + "sysdoc")
                if (!Q.isEmptyOrNull(sysdoc)) {
                   
                    let  q = Q.tryFirst(PoPurRequestRow.getLookup().items, x => x.SysDocNo == sysdoc)
                    console.log(q)
                    if(q.ApproveFg == 1 || q.CancelFg == 1|| q.SendForAppfg == 1){
                    this.HdPostfg = 1;
                    console.log(q.ApproveFg)
                    this.toolbar.findButton('button-saveandnew').toggleClass('disabled', false);
                    this.toolbar.findButton('button-saveandnew').hide();
                    Serenity.EditorUtils.setReadOnly(this.form.VatCode, true);
                    Serenity.EditorUtils.setReadOnly(this.form.Qty, true);
                    Serenity.EditorUtils.setReadOnly(this.form.PurUnitPrice, true);
                    Serenity.EditorUtils.setReadOnly(this.form.Remark, true);
                    Serenity.EditorUtils.setReadOnly(this.form.DiscText, true);
                    Serenity.EditorUtils.setReadOnly(this.form.UnitChange, true);
                    }
                   
                }
           
            

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
            let f = this.form;
            // if (f.SkuCode.value != null) {
            /* let self = this;*/

            // self.toolbar.findButton("button-skucode").addClass("skuStockStatus");
            // self.toolbar.findButton('button-newdelete').addClass("skuEssential");
            // }

        }

        


      

        private CallSku() {
            var sku: string = this.form.SkuCode.value
            var skucode: string = Q.toId(this.form.SkuCode.value);
            var stku = this.StkUnit;
            //var puru = this.PurUnit;
            console.log(skucode)
            console.log(sku)
            console.log(stku)

           
            if (skucode != null) {
                let skucode = Q.tryFirst(Product.CsSkuRow.getLookup().items, x=> x.SkuCode == sku)
                this.StkUnitT = skucode.StkUnit;
                this.purratio = skucode.PurUnitRatio;
                this.purpz = skucode.PurUnitPrice;
                this.lsprun = skucode.LastPurPrice;
                let vat: string = skucode.VatCode;
                let vattype: string = skucode.VatType;
                this.form.VatType.value = vattype
                this.form.VatCode.value = vat
                //console.log(vat + "||" + vattype)
                this.form.VatRate.value = Administration.CsVatCodeRow.getLookup().itemById[vat].VatRate

                // this.StkUnitT = skucode.StkUnit;
                this.form.PurUnit.value = skucode.StkUnit;
                this.form.PurUnitRatio.value = 1;
                this.form.SkuDesc.value = skucode.SkuDesc + " X " + this.StkUnitT;
                if(this.isNew()){
                this.form.Qty.value = 1;
                }
                if (this.purratio == 0) {
                    this.form.PurUnitPrice.set_value(0);
                    this.form.LastPurUnitPrice.set_value(0);
                } else {
                    this.form.PurUnitPrice.value = this.purpz / (this.purratio || 1);
                    this.form.LastPurUnitPrice.value = this.lsprun / (this.purratio || 1);
                    this.form.UnitCost.value = this.purpz / (this.purratio || 1);

                }

                this.form.VatType.value = vattype
                this.form.VatCode.value = vat
                this.form.VatRate.value = Administration.CsVatCodeRow.getLookup().itemById[vat].VatRate
                
                if(this.lookupconsignfg == 1){
                    this.form.DiscText.value = skucode.ConsignGp.toString()+"%"
                }
                    this.Calamt();
                
            }
        }
        private callpurunit() {

            var sku: string = this.form.SkuCode.value
            var skucode: string = Q.toId(this.form.SkuCode.value);
            var stku = this.StkUnit;
            var puru = this.PurUnit;
            console.log(skucode)
            console.log(sku)
            console.log(stku)

            if (skucode != null) {

                let skucode = Q.tryFirst(Product.CsSkuRow.getLookup().items, x=> x.SkuCode == sku)
                this.StkUnitT = skucode.StkUnit;
                this.purratio = skucode.PurUnitRatio;
                this.purpz = skucode.PurUnitPrice;
                this.lsprun = skucode.LastPurPrice;
                let vat: string = skucode.VatCode;
                let vattype: string = skucode.VatType;
                this.form.VatType.value = vattype
                this.form.VatCode.value = vat
                
                this.form.VatRate.value = Administration.CsVatCodeRow.getLookup().itemById[vat].VatRate
                


                this.form.PurUnit.value = skucode.PurUnit;
                this.form.PurUnitRatio.value = this.purratio
                this.form.PurUnitPrice.value = this.purpz
                this.form.LastPurUnitPrice.value = this.lsprun
                this.form.SkuDesc.value = skucode.SkuDesc + " (X" + this.form.PurUnitRatio.value.toString() + " " + this.StkUnitT + ")" + this.form.PurUnit.value;

                this.form.UnitChange.value = "1";


                this.form.UnitCost.value = this.form.PurUnitPrice.value / (this.purratio || 1);
                if(this.lookupconsignfg == 1){
                    this.form.DiscText.value = skucode.ConsignGp.toString()+"%"
                }
                    this.Calamt();
                
            }

            

        }

        private syscuscheck() {
            
            let lookupconsignfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 21 && x.SysFg > 0)        

            if (lookupconsignfg != null) {
                this.lookupconsignfg = 1;               
            } else {
                this.lookupconsignfg = 0;
            }
            // VatCode

            let vatcode = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 73 && x.SysFg > 0)        

            if (vatcode != null) {
                Serenity.EditorUtils.setReadOnly(this.form.VatCode, false); 
            } else {
                Serenity.EditorUtils.setReadOnly(this.form.VatCode, true);
            }

        }



        private Calamt() {

            
            this.form.BeforeDiscAmt.value = (this.form.PurUnitPrice.value) * (this.form.Qty.value);

            // this.form.ItemAmt.value = (this.form.BeforeDiscAmt.value - this.form.DiscAmt.value) 
            
            // this.form.ItemNetAmt.value = this.form.ItemAmt.value - (this.form.AlocalteDiscAmt.value || 0);
            // console.log(this.form.DiscAmt.value + "dis");
            this.distext();


        }
        

        private distext() {
            var discStr = this.form.DiscText.value;
           
            if (!Q.isEmptyOrNull(discStr)) {
                //20%,5%,200

                let a = discStr.split(",")
                console.log(a)
                var totalAmt = this.form.BeforeDiscAmt.value;
                var discamt = 0
                //var net = 0

                for (var po of a) {

                    if (po.includes("%")) {
                        let a = po.replace("%", "");
                        let b = Number(a);
                        console.log(b)
                        let amt = totalAmt * b / 100
                        discamt = discamt + amt;
                        totalAmt = totalAmt - amt;
                    } else {
                        let x = Number(po)
                        discamt = discamt + x
                        totalAmt = totalAmt - x;
                    }

                }

                console.log("Lasttotal:" + totalAmt)
                console.log("DiscAmt:" + discamt)

                this.form.DiscAmt.value = discamt
                this.form.ItemAmt.value = totalAmt
                this.form.ItemNetAmt.value = totalAmt - (this.form.AlocalteDiscAmt.value || 0)
                this.CalVat();
            }else{
                this.form.DiscAmt.value = 0
                this.form.ItemAmt.value = this.form.BeforeDiscAmt.value
                this.form.ItemNetAmt.value = this.form.ItemAmt.value - (this.form.AlocalteDiscAmt.value || 0)
                this.CalVat();
            }
        }

        private CalVat() {

            const Totalafterdis = this.form.ItemNetAmt.value
            var vatRate = this.form.VatRate.value
            var salev = this.form.SalesVatTypes.value
            
            console.log("vattype:"+salev)
            if (salev == "E") {

                this.form.ItemVatAmt.value = (Totalafterdis * (vatRate / 100));
                this.form.ItemExVatAmt.value = Totalafterdis
                this.form.ItemNetCostValue.value = Totalafterdis+this.form.ItemVatAmt.value
            }    //vat นอก       
            else {
                this.form.ItemVatAmt.value = (Totalafterdis * vatRate) / (vatRate + 100);
                this.form.ItemExVatAmt.value = Totalafterdis - this.form.ItemVatAmt.value
                this.form.ItemNetCostValue.value = Totalafterdis 
            }

        }


    }




}





